<div class="table-responsive">
  <table
    id="data-table"
    class="table text-nowrap m-0 table-bordered table-striped"
    >
    @if (list.length > 0 && !showLoading) {
      <thead class="table-head">
        <tr class="text-secondary bg-gray-200">
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            [ngClass]="renderArrowIcon('enrollmentno')"
            (click)="applySort('enrollmentno')">
            MEMBER ID
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            (click)="applySort('patient')"
            [ngClass]="renderArrowIcon('patient')">
            PATIENT
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            (click)="applySort('nephrologist')"
            [ngClass]="renderArrowIcon('nephrologist')">
            NEPHROLOGIST
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            (click)="applySort('dob')"
            [ngClass]="renderArrowIcon('dob')">
            DOB (AGE)
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            (click)="applySort('stage')"
            [ngClass]="renderArrowIcon('stage')">
            STAGE
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            (click)="applySort('riskcategory')"
            [ngClass]="renderArrowIcon('riskcategory')">
            RISK CATEGORY
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            (click)="applySort('caremember')"
            [ngClass]="renderArrowIcon('careMember')">
            SOMATUS LEAD
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            [ngClass]="renderArrowIcon('status')"
            (click)="applySort('status')">
            STATUS
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            [ngClass]="renderArrowIcon('acuteinpatientcount')"
            (click)="applySort('acuteinpatientcount')"
            >
            # OF IP VISITS
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            [ngClass]="renderArrowIcon('totaladmissionscount')" (click)="applySort('totaladmissionscount')"
            >
            # OF TOTAL ADMINSSIONS
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            [ngClass]="renderArrowIcon('latestadmission')"
            (click)="applySort('latestadmission')">
            LAST ADMINSSION
          </th>
          <th class="bg-transparent border-bottom-0 fs-12 table-header pe-5"
            [ngClass]="renderArrowIcon('dischargedate')"
            (click)="applySort('dischargedate')">
            LAST DISCHARGE
          </th>
          <th class="bg-transparent border-bottom-0 no-btn fs-12 wp-3"></th>
        </tr>
      </thead>
    }
    @if (showLoading) {
      <tbody class="table-body">
        @for (i of getIterations(); track i) {
          <tr>
            <td><span class="skeleton-loader my-1"></span></td>
            <td><span class="skeleton-loader my-1"></span></td>
            <td><span class="skeleton-loader my-1"></span></td>
            <td><span class="skeleton-loader my-1"></span></td>
            <td><span class="skeleton-loader my-1"></span></td>
            <td><span class="skeleton-loader my-1"></span></td>
            <td><span class="skeleton-loader my-1"></span></td>
            <td><span class="skeleton-loader my-1"></span></td>
            <td><span class="skeleton-loader my-1"></span></td>
          </tr>
        }
      </tbody>
    }
    @if (!showLoading) {
      <tbody class="table-body">
        @for (item of list; track item) {
          <tr>
            <td>
              <div class="d-flex align-items-center">
                <div class="user-details ms-2">
                  <a
                    class="text-secondary"
                    href="javascript: void(0)"
                    (click)="patientHandler(item, 'detail')"
                    ><h6 class="mb-0">{{ item.enrollmentNo }}</h6></a
                    >
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <i data-bs-toggle="tooltip" data-bs-placement="top" class="fa" ></i>
                  <div class="user-details ms-2">
                    <a
                      class="text-secondary"
                      href="javascript: void(0)"
                      (click)="patientHandler(item, 'detail')"
                      ><h6 class="mb-0">{{ item?.fullName }}</h6></a
                      >
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <div class="user-details ms-2">
                      {{ item.nephrologistName ? item.nephrologistName : '-' }}
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  {{ getFormatDate(item.dob)
                  }}<strong class="fw-semibold"> ({{ getAge(item.dob) }})</strong>
                </td>
                <td class="text-center">{{ item.stage }}</td>
                <td>
                  <div class="d-flex">
                    <div class="flex-fill">
                      <div class="progress progress-sm mt-1">
                        @if (item.riskCategory === 'Medium') {
                          <div
                            class="progress-bar bg-warning wp-50"
                          ></div>
                        }
                        @if (item.riskCategory === 'Low') {
                          <div
                            class="progress-bar bg-success wp-25"
                          ></div>
                        }
                        @if (
                          item.riskCategory === 'High' ||
                          item.riskCategory === 'Highest'
                          ) {
                          <div
                            class="progress-bar bg-danger wp-75"
                          ></div>
                        }
                      </div>
                    </div>
                    <div class="ms-2">{{ item.riskCategory }}</div>
                  </div>
                </td>
                <td class="text-center">{{ item.careMember }}</td>
                <td class="text-center">{{ item.status }}</td>
                <td class="text-center">{{ item.acuteInpatientCount }}</td>
                <td class="text-center">{{ item.totalAdmissionsCount }}</td>
                <td class="text-center">
                  {{ getFormatDate(item.admissionDate) }}
                  <strong class="fw-semibold"></strong>
                </td>
                <td class="text-center">
                  {{ getFormatDate(item.dischargeDate)
                  }}<strong class="fw-semibold"></strong>
                </td>
                <td class="text-center">
                  <a
                    href="#"
                    class="br-5 px-2 py-1"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    ><i class="fe fe-more-vertical"></i
                  ></a>
                  <div class="dropdown-menu dropdown-menu-start">
                    <a
                      class="dropdown-item"
                      href="Javascript: void(0);"
                      routerLink="/admission" (click)="trackNavigation(item.patientId)"
                      ><i class="fe fe-info me-2"></i> Detail</a
                      >
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
        @if (list.length === 0 && !showLoading) {
          <app-no-records-found
          ></app-no-records-found>
        }
        @if (list.length > 0 && !showLoading) {
          <app-pagination
            [attributePatients]="attributePatients"
            [pagingModel]="gridData.pagingModel"
            (gotoPageHandler)="gotoPage($event)"
            >
          </app-pagination>
        }
      </div>
